const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Quick boolean check whether a string matches the canonical UUID v1-v5
 * format (8-4-4-4-12 lowercase hex, case-insensitive). Mirrors the
 * existing pattern in `validators/email.ts:isValidEmail`.
 */
export function isUUID(input: string): boolean {
  return UUID_REGEX.test(input);
}
